import React from 'react';
import { studentStatus } from '../../domain/people';
import s from './StatusBadge.module.css';

// A student's status as a pill, coloured by the status — colour is what people
// read first in a table, so it must not contradict the word. The word is
// always shown, never colour alone.

// Keyed on the stored value, and there is one key per entry in `STATUSES`
// (columns.js). A status with no tone here falls through to the inactive grey,
// which is the failure this component was written to stop — so
// test/ui/studentStatus.test.jsx asserts the two lists agree rather than
// trusting a reader to notice.
const TONE = {
  active: s.active,
  trial: s.trial,
  waiting: s.waiting,
  // Lead's pink is MMS's own (#177): #604274 on #F9E5FF, the one status whose
  // colours are measured rather than a token (see the stylesheet).
  lead: s.lead,
  inactive: s.inactive,
};

export default function StatusBadge({ status }) {
  const value = studentStatus(status);
  return <span className={[s.badge, TONE[value] || s.inactive].join(' ')}>{value}</span>;
}
